import MainButton from "../../../components/button/mainButton";
import "../../../assets/styles/admin/opd.scss";
import React, { useState, useEffect } from "react";
import { mdiPrinter, mdiFileUploadOutline } from "@mdi/js";
import Icon from "@mdi/react";
import HeaderBar from "../../../components/header/headerBar";
import { useHistory, useLocation, useParams } from "react-router-dom";
import queryString from "query-string";
import axios from "axios";

const OPDView = () => {
  const location = useLocation();

  interface ParamsType {
    id: string;
  }

  const { id } = useParams<ParamsType>();
  const [loading, setLoading] = useState<Boolean>(false);
  const [state, setState] = useState<any>({
    cards: [],
  });

  const { search } = useLocation();
  const query = queryString.parse(search);

  interface Props {
    card: any;
    No: string;
    totalNo: string;
    date: string;
    cn: string;
    name: string; // edited.
    course: string;
    branch: string;
    doctorName: string;
    opdStatus?: string;
    isRequestComplicationDisabled?: boolean;
  }
  const OPDViewCard: React.FC<Props> = ({
    card,
    No,
    date,
    cn,
    name,
    course,
    totalNo,
    branch,
    doctorName,
    opdStatus,
    isRequestComplicationDisabled,
  }) => {
    const history = useHistory();
    const [selectedCard, setSelectedCard] = useState<any>({});

    const handleChange = async (e: any, updatePath: string) => {
      const { files } = e.target;
      console.log("files =>", files);
      if (files.length) {
        console.log("uploading file...");

        try {
          const fmData = new FormData();
          const config = {
            headers: { "content-type": "multipart/form-data" },
          };

          fmData.append("file", files[0]);

          await axios.patch(updatePath, fmData, config);
        } catch (err: any) {
          console.log("err =>", err);
        }
      }
    };

    function onComplication(courseRecordId: string) {
      history.push(`/opd/list/${id}/view/complication/${courseRecordId}`);
    }
    function onUploadOPD() {
      history.push(`${location.pathname}/opd/${No}`);
    }
    function onEditDoctor() {
      history.push(
        `/usedcourse/coursedetail/${query.soId}/courseList1?itemId=${query.itemId}&type=edit`
      );
      // history.push(`${location.pathname}/edit-doctor/${No}`);
    }
    function onRecord() {
      history.push(`${location.pathname}/usage-log/${No}`);
    }

    return (
      <div className="opd-view-card">
        <div className="opd-header">
          <div>
            ครั้งที่ {No} / Times {No}
          </div>
          <div>{date}</div>
        </div>
        <div className="opd-container">
          <div className="opd-row row-1">
            <div className="contant">{cn}</div>
            <div className="contant">{name}</div>
          </div>
          <div className="opd-row row-2">
            <div className="contant">{course}</div>
            <div className="contant">{`${No}/${totalNo}`}</div>
          </div>
          <div className="opd-row row-3">
            <div className="contant color-fix">
              Branch purchased/used สาขาที่ซื้อ/ใช้
            </div>
            <div className="contant">{branch}</div>
          </div>
          <div className="opd-row row-4">
            <div className="contant color-fix">Therapist/Doctor</div>
            <div className="contant">
              <div>{doctorName}</div>
              <div
                className="color-fix font-fix"
                onClick={onEditDoctor}
                style={{ color: "#5BAEA9" }}
              >
                View/Edit
              </div>
            </div>
          </div>
          <div className="opd-row row-5">
            <div className="contant color-fix">เลขที่ใบยา</div>
            <div className="contant">
              {/* <label htmlFor="img"> */}
              <div
                id="rounded"
                onClick={() => {
                  setSelectedCard({ ...card });
                  const ref = document.getElementById("file-leaf-number");
                  console.log("ref =>", ref);
                  ref?.click();
                }}
              >
                <Icon path={mdiFileUploadOutline} size="20" color="#fff" />
              </div>
              {/* </label> */}
              <input
                type="file"
                id="file-leaf-number"
                name="file-leaf-number"
                accept="image/*"
                hidden
                onChange={(e: any) => {
                  handleChange(
                    e,
                    `/member-so/upload-leaf-number?cardId=${selectedCard?._id}`
                  );
                }}
              />
            </div>
          </div>
          <div className="opd-row row-6">
            <div className="contant color-fix">ใบเซ็น</div>
            <div className="contant">
              {/* <label htmlFor="img-2"> */}
              <div
                id="rounded"
                onClick={() => {
                  setSelectedCard({ ...card });
                  const ref = document.getElementById("file-sign");
                  console.log("ref =>", ref);
                  ref?.click();
                }}
              >
                <Icon path={mdiFileUploadOutline} size="20" color="#fff" />
              </div>
              {/* </label> */}
              <input
                type="file"
                id="file-sign"
                name="img"
                accept="image/*"
                hidden
                onChange={(e: any) => {
                  handleChange(
                    e,
                    `/member-so/upload-sign?cardId=${selectedCard?._id}`
                  );
                }}
              />
            </div>
          </div>
          <div
            className="opd-row row-7 actions"
            style={{ padding: "10px 20px" }}
          >
            <MainButton
              title="Request Complication"
              width="100px"
              background="#EA5050"
              onClick={() => {
                onComplication(card?._id);
              }}
              disabled={isRequestComplicationDisabled}
            />
            <MainButton
              title="บันทึกการใช้ UsageLog"
              width="100px"
              background="#5BAEA9"
              onClick={onRecord}
            />
            <MainButton
              title="Upload OPD"
              width="100px"
              onClick={onUploadOPD}
            />
          </div>
        </div>
      </div>
    );
  };

  const getData = async () => {
    try {
      const { data } = await axios.get(
        `/member-so/cards?soId=${query.soId}&itemId=${query.itemId}`
      );
      console.log("data22 =>", data?.data);
      if (!data) return;

      const cards =
        data.data?.map((x: any, index: number) => ({ ...x, no: index + 1 })) ||
        [];

      console.log("cards =>", cards);

      setState({ ...state, cards });
    } catch (err) {
      console.log("error =>", err);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <HeaderBar
        btnBack={true}
        title="บันทึกการใช้ / น.ส.รังสิมา แซ่หว่าง (EK-CNT60100015)"
      >
        <MainButton
          title="REFUND"
          to={`${location.pathname}/refund`}
          background="#E76464"
        />
      </HeaderBar>
      <div style={{ padding: "0px 40px", margin: "10px 30px" }}>
        {/* <div className="flex end">
          <MainButton
            title="REFUND"
            to={`${location.pathname}/refund`}
            background="#E76464"
          />
        </div> */}
        <div className="opd-view history">
          {state.cards.map((item: any, index: number) => (
            <OPDViewCard
              No={item.amountRecord}
              date={item.formatCreatedAt}
              cn={item.customerUsedCode}
              name={item.customerUsedName}
              course={item.item?.name}
              totalNo="10"
              branch={`${item.branchPurchased}/${item.branchUsed}`}
              doctorName="ดร.อภิชญา ธัญญาวุฒิ"
              opdStatus=""
              key={index}
              card={item}
              isRequestComplicationDisabled={
                index > 0 || index === state.cards.length - 1
              }
            />
          ))}
        </div>
      </div>
    </div>
  );
};
export default OPDView;
